import { Routes, Route } from 'react-router-dom'
import Login from './Login'
import BlogCategory from './components/BlogCategory'
import Index from './components/Index'
import ProtectedRoute from './components/ProtectedRoute'
import { UserAuthContextProvider } from './context/UserAuthContext'
import BlogList from './components/BlogList'
import BlogCategoryList from './components/BlogCategoryList'
import Blog from './components/Blog'
import EditBlogcat from './components/EditBlogCat'
import EditBlog from './components/EditBlog'
import BusinessAnalysis from './components/BusinessAnalysis'
import TextEditor from './components/TextEditor'
import Logout from './Logout'
import Certificates from './components/Certificates'
import Gallery from './components/Gallery'
import Media from './components/Media'
import EventsGallery from './components/EventsGallery'
import SewingApplicationsList from './components/lssf/SewingApplicationsList'
import HealthApplicationsList from './components/lssf/HealthApplicationsList'
import TricycleApplicationsList from './components/lssf/TricycleApplicationsList'
import CataractApplicationsList from './components/lssf/CataractApplicationsList'
import FarmerApplicationsList from './components/lssf/FarmerApplicationsList'
import RunningCompetitionList from './components/lssf/RunningCompetitionList'
import ContactEnquiriesList from './components/lssf/ContactEnquiriesList'
import DonationsList from './components/lssf/DonationsList'
import CounselingDetails from './components/mbbs/CounselingDetails'
import ContactEnquiry from './components/mbbs/ContactEnquiry'
import StudentsList from './components/mbbs/StudentsList'
import CollegeList from './components/mbbs/CollegeList'
import CityList from './components/mbbs/CityList'
import NewsEventsManagement from './components/mbbs/NewsEventsManagement'

const App = () => {
  return (
    <UserAuthContextProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path='dashboard' element={<ProtectedRoute><Index /></ProtectedRoute>}>





          <Route path="certificates" element={<Certificates />} />
          <Route path="media" element={<Media />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="events" element={<EventsGallery />} />










          {/* <Route path="blog-category" element={<BlogCategory />} />
          <Route path="blog-category-list" element={<BlogCategoryList />} />
          <Route path="blog-category-edit/:blog_id" element={<EditBlogcat />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog-list" element={<BlogList />} /> */}
          <Route path='dash_board' element={<BusinessAnalysis />} />
          <Route path="logout" element={<Logout />} />

          <Route path="lssf/sewing-applications" element={<SewingApplicationsList />} />
          <Route path="lssf/health-applications" element={<HealthApplicationsList />} />
          <Route path="lssf/tricycle-applications" element={<TricycleApplicationsList />} />
          <Route path="lssf/cataract-applications" element={<CataractApplicationsList />} />
          <Route path="lssf/farmer-applications" element={< FarmerApplicationsList />} />
          <Route path="lssf/running-competition" element={<RunningCompetitionList />} />
          <Route path="lssf/contact-enquiries" element={<ContactEnquiriesList />} />
          <Route path="lssf/donations" element={<DonationsList />} />

          <Route path="mbbs/counseling-details" element={<CounselingDetails />} />
          <Route path="mbbs/contact-enquiry" element={<ContactEnquiry />} />
          {/* <Route path="mbbs/cutoff-buy" element={<CutoffBuy/>} /> */}
          <Route path="mbbs/students-list" element={<StudentsList />} />
          <Route path="mbbs/college-list" element={<CollegeList />} />
          <Route path="mbbs/blog-list" element={<BlogList />} />
          <Route path="mbbs/city-list" element={<CityList />} />
          <Route path="mbbs/news-events" element={<NewsEventsManagement/>} />

        </Route>
        <Route path='ckeditor' element={<TextEditor />} />
      </Routes>
    </UserAuthContextProvider>
  )
}

export default App